/* eslint-disable */

import Vue from 'vue';
import api from './../api';
import signUp from './signup';
import store from './../../store';
import { Indicator, Toast } from 'mint-ui';
import hello from 'hellojs';

// When the request succeeds
const success = (token) => {
  if (token !== null) {
    store.dispatch('login', token);
  }
  /* Goes to last path if exist if not goes home */
  if (localStorage.getItem('to') === null) {
    Vue.router.replace({
      name: 'home',
    });
  } else {
    // Return to the next route
    Vue.router.replace({
      path: localStorage.getItem('to'),
    });
    // Removeing the [to] record
    localStorage.removeItem('to');
  }
};

// When the request fails
const failed = (text) => {
  // eslint-disable-next-line
  Toast({
    message: text,
    position: 'bottom',
    duration: 4000,
  });
};

export default async (user, channel) => {
  let api_google = '';
  if (localStorage.getItem('codigoPais') === 'CL') {
    api_google = '37522317405-230k6migghrhfes3gnb3s9covi68h896.apps.googleusercontent.com';
  } else {
    api_google = '733150967262-07f5n8gg3p5h7lgkfkejbjfhn4bpksbq.apps.googleusercontent.com';
  }
  hello.init({
  	// facebook: 138462032944482,
    facebook: 607995632590646,
    google: api_google
  }, {redirect_uri: '/'});
  switch (channel) {
    case 'facebook': {
      ga('send', 'event', 'Button', 'click', 'Login: Login Facebook');
      let microtime = new Date().valueOf();
      let tokenSocial = microtime * 1000;
      tokenSocial += Math.floor(Math.random() * 9999) + 1000;
      var channel = 'facebook';
      var api_social = process.env.API_SOCIAL_LOCATION;
      var url= api_social+'facebook/login';
      var title = "Api Social";
      var w = 580;var h = 400;
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
      var left = ((width / 2) - (w / 2)) + dualScreenLeft;
      var top = ((height / 2) - (h / 2)) + dualScreenTop;
      var origin = 'web-mobile';
      var mdlSocial = window.open(url+'?token='+tokenSocial+"&origin="+origin, 'apisocial', 'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left+',toolbar=0,scrollbars=0resizable=0,location=1,menuBar=0');
      var interval = setInterval(() => {
        if(mdlSocial.closed) {
          clearInterval(interval);
          const rs = api.get(api_social+'facebook/info?soctoken='+tokenSocial).then(function(response) {
              user.nombre = response.data.Nombre;
              user.apellido= response.data.Apellido;
              user.email = response.data.Email;
              user.eresasistente = 0;
              user.redsocial = 1;
              user.tokenredsocial = response.data.Token;
              user.so = 1;
              user.idredsocial = response.data.socialId;
              user.webmovil = 1;
              if(user.email!=null){
                signUp(user);
              }else{
                localStorage.setItem('userNombre',user.nombre);
                localStorage.setItem('userApellido',user.apellido);
                // Return to the next route
                Vue.router.replace({
                  path: '/signup',
                });
              }
          })
          .catch(function(error) {
            failed('Imposible login a través de Facebook');
          });
        }
      }, 2000);
      break;
    }
    /**
    case 'facebook': {
      ga('send', 'event', 'Button', 'click', 'Login: Login Facebook');
      let res = null;
      res = await hello('facebook').login();
      if (res.authResponse) {
        const rs = await hello('facebook').api('me?fields=email,first_name,last_name,gender');
        user.nombre = rs.first_name;
        user.apellido= rs.last_name;
				user.email = rs.email;
        if(rs.gender) {
            if(rs.gender == 'male') user.sexo = '0';
            if(rs.gender == 'female') user.sexo = '1';
        }
        user.eresasistente = 0;
        user.redsocial = 1;
        user.tokenredsocial = res.authResponse.access_token;
        user.so = 1;
        user.idredsocial = rs.id;
        user.webmovil = 1;
        if(user.email!=null){
          signUp(user);
        }else{
          localStorage.setItem('userNombre',user.nombre);
          localStorage.setItem('userApellido',user.apellido);
          // Return to the next route
          Vue.router.replace({
            path: '/signup',
          });
        }
      } else {
        failed('Imposible login a través de Facebook');
      }
      break;
    }**/
    case 'google': {
      ga('send', 'event', 'Button', 'click', 'Login: Login Gmail');
      let res = null;
      res = await hello('google').login({ options: { scope: 'email' } });
      if (res.authResponse) {
        const rs = await hello('google').api('me');
        user.nombre = rs.first_name;
        user.apellido= rs.last_name;
        user.email = rs.email;
        if(rs.gender) {
            if(rs.gender == 'male') user.sexo = '0';
            if(rs.gender == 'female') user.sexo = '1';
        }
        user.eresasistente = 0;
        user.redsocial = 1;
        user.tokenredsocial = res.authResponse.access_token;
        user.so = 1;
        user.webmovil = 1;
        if(user.email!=null){
          signUp(user);
        }else{
          localStorage.setItem('userNombre',user.nombre);
          localStorage.setItem('userApellido',user.apellido);
          // Return to the next route
          Vue.router.replace({
            path: '/signup',
          });
        }
      } else {
        failed('Imposible login a través de Google');
      }
      break;
    }
    default: {
      ga('send', 'event', 'Button',' click', 'Login: Send Login');
      Indicator.open({
        text: 'Redirecting...',
        spinnerType: 'triple-bounce'
      });
      user.webmovil = 1;
      const rs = await api.post('login/loginEP/', user);
      Indicator.close();
      if (rs.data.status === 200) {
        success(rs.data.data.token);
      } else {
        failed(rs.data.mensaje);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/services/auth/login.js